import axios from 'axios'
import * as types from '../mutation-types'

import { createTheParametersOfTheUrl } from '../../plugins/helper'

// state
export const state = {
  loadingBlueprints: true,
  blueprints: [],
  errorBlueprints: {},
}

const allBlueprints = blueprints => {
  const term = []
  if (blueprints && blueprints.length > 0) {
    Object.keys(blueprints).forEach(key => {
      const flat = blueprints[key]
      term.push({
        value: flat.id,
        text: flat.modelo,
      })
    })
  }

  return term
}

// mutations
export const mutations = {
  [types.GET_BLUEPRINTS_START] (state) {
    state.loadingBlueprints = true
    state.blueprints = []
    state.errorBlueprints = {}
  },

  [types.GET_BLUEPRINTS_SUCCESS] (state, { data }) {
    state.loadingBlueprints = false
    state.blueprints = allBlueprints(data)
    state.errorBlueprints = {}
  },

  [types.GET_BLUEPRINTS_ERROR] (state, { error }) {
    state.loadingBlueprints = false
    state.blueprints = []
    state.errorBlueprints = error
  },
}

export const actions = {
  async getBlueprints ({ commit }, payload) {
    try {
      commit(types.GET_BLUEPRINTS_START)

      const href = createTheParametersOfTheUrl(payload)
      const { data } = await axios.get(`/api/permission/planos/list${href}`)

      commit(types.GET_BLUEPRINTS_SUCCESS, { data })
    } catch (e) {
      const { response } = e
      commit(types.GET_BLUEPRINTS_ERROR, { error: response })
    }
  },
}

// getters
export const getters = {
  loadingBlueprints: state => state.loadingBlueprints,
  blueprints: state => state.blueprints,
  errorBlueprints: state => state.errorBlueprints,
}
